<div class="card mb-3">
  <div class="card-body">
    <h3>{{ booking.firstName + ' ' + booking.lastName }}</h3>
    <div class="py-2 zaya-form-help-text">{{ booking.createdAt | date }}</div>
    <div class="py-1">
      <fa-icon class="mr-3" [icon]="emailIcon"></fa-icon>
      <span>{{ booking.email }}</span>
    </div>
    <div>
      <fa-icon class="mr-3" [icon]="phoneIcon"></fa-icon>
      <span>{{ booking.phoneNumber }}</span>
    </div>
    <hr>
    <div class="py-1">Contact preference: {{ booking.preferredContact }}</div>
    <div class="py-1">
      Service selected: {{ getTherapyNames(booking.services) }}
    </div>
    <div class="py-1">Session preference: {{ booking.type }}</div>
    <div class="py-1">Requested Session Dates:</div>
    <div class="py-1" *ngFor="let date of booking.requestedDates">{{ date.date | date }} - {{ date.time }}</div>

    <button
      *ngIf="!booking.isCompleted else completed"
      gaEvent
      gaCategory="Bookings Page"
      [gaAction]="'Mark booking as completed'"
      [gaLabel]="'click'"
      class="btn btn-primary schedule-btn mt-3"
      type="button"
      (click)="markAsCompleted()"
      i18n="button|The button text for completing a booking.@@buttonMarkCompleted">Mark as completed</button>

    <ng-template #completed>
      <button
        disabled
        class="btn btn-primary schedule-btn mt-3"
        type="button"
        i18n="button|The button text for completed booking.@@buttonCompleted">Completed</button>
    </ng-template>
  </div>
</div>
